import { render } from "./spaPromotion.vue?vue&type=template&id=a90f1c12&scoped=true"
import script from "./spaPromotion.vue?vue&type=script&lang=js"
export * from "./spaPromotion.vue?vue&type=script&lang=js"

import "./spaPromotion.vue?vue&type=style&index=0&id=a90f1c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90f1c12"]])

export default __exports__